"use client";
import React, { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { HiExternalLink } from "react-icons/hi";
const Hero = (
  { heroData }: {
    heroData: {
      id: number;
      sectiontype: string;
      topheader: string;
      titlename: string;
      bottomheader: string;
      action: string;
      actionlink: string;
      imageurl: string;
      isactive: number;
    }[];
  }
) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  // auto animate carousel
  const itemsRef = React.useRef<NodeListOf<HTMLDivElement> | null>(null);
  useEffect(() => {
    itemsRef.current = document.querySelectorAll(".hero-item");
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % heroData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroData]);

  useEffect(() => {
    itemsRef.current?.forEach((item, i) => {
      item.style.transform = `translateX(-${activeIndex * 100}%)`;
    });
    // set opacity to zero for all items
    itemsRef.current?.forEach((item, i) => {
      if (i !== activeIndex) {
        item.style.opacity = "0";
      } else {
        item.style.opacity = "1";
      }
    });
  }, [activeIndex]);

  return (
    <section className={`w-full flex flex-col items-center justify-center py-8 bg-[#551013]`}
    >
      <div
        className="w-[94%] max-w-[1440px] mx-auto flex flex-col justify-center items-center gap-8 rounded-lg py-8 overflow-hidden relative p-4 md:h-[480px] h-[720px]">
        {
          heroData.map((item, i) => {
            return (
              <div style={{
                left: `${i * 100}%`,
              }} key={item.id} className="hero-item w-full transition-all duration-1000 min-w-full max-w-full grid md:grid-cols-2 grid-cols-1 items-center text-white overflow-hidden absolute top-0">
                <div className="flex flex-col justify-center items-center lg:gap-4 md:gap-2 gap-1 w-full">
                  <div className="text-left flex flex-col w-full lg:gap-4 md:gap-2 gap-1">
                    <h1 className="md:text-xl lg:text-2xl text-lg font-normal text-white">{item.topheader}</h1>
                    <h2 className="lg:text-5xl md:text-4xl text-2xl font-bold text-white">{item.titlename}</h2>
                    <h3 className="lg:text-2xl md:text-xl text-lg font-normal text-white">{item.bottomheader}</h3>
                    <div className="flex items-center  lg:gap-4 md:gap-2 gap-1 mt-2 flex-wrap w-full">
                      <Link href={item.actionlink} className="text-center w-fit whitespace-nowrap px-4 max-w-[200px] md:text-lg lg:text-xl text-base py-2 bg-orange-500 text-white font-normal hover:bg-orange-700 transition-colors  rounded-md">
                        {item.action}
                      </Link>

                      <Link href={`https://order.online/business/~12620887/`} target="_blank" className="text-center px-4 max-w-[260px] md:text-lg lg:text-xl text-base py-2 flex items-center justify-center w-full bg-orange-600 text-white font-normal hover:bg-orange-700 transition-colors gap-2 rounded-md">
                        <span>Order Drinks Now</span>
                        <HiExternalLink size={20} />
                      </Link>
                    </div>

                    <Link href={`https://www.ezcater.com/catering/pvt/chaivio-3?fcv=1`} target="_blank" className="text-center px-4 max-w-[260px] md:text-lg lg:text-xl text-base py-2 flex items-center justify-center bg-[#00B373] text-white font-normal hover:bg-[#28926d] transition-colors gap-2 rounded-md">
                      <span>Order With ezCater</span>
                      <HiExternalLink size={20} />
                    </Link>
                  </div>
                </div>
                <div className="w-full">
                  <Image src={item.imageurl} alt={item.titlename} width={500} height={500} className="md:w-[360px] w-full max-md:mt-4 md:h-[360px] md:rounded-full object-cover object-center md:ml-auto rounded-xl" />
                </div>
              </div>
            )
          })
        }
        <div className="absolute bottom-0 left-0 w-full flex justify-center items-center gap-4">
          {
            heroData.map((item, i) => {
              return (
                <button key={item.id} onClick={() => setActiveIndex(i)} className={`w-4 h-4 rounded-full bg-white ${activeIndex === i ? "opacity-100" : "opacity-50"}`}></button>
              )
            })
          }
        </div>
      </div>
    </section>
  );
};

export default Hero;
